import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const renderPaginationNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <p
            key={i}
            onClick={() => onPageChange(i)}
            className={`cursor-pointer ${
              currentPage === i
                ? "text-white"
                : "text-[#CACFD8] hover:text-white"
            }`}
          >
            {i}
          </p>,
        );
      }
    } else {
      pages.push(
        <p
          key={1}
          onClick={() => onPageChange(1)}
          className={`cursor-pointer ${
            currentPage === 1 ? "text-white" : "text-[#CACFD8] hover:text-white"
          }`}
        >
          1
        </p>,
      );

      if (currentPage > 3) {
        pages.push(
          <p key="start-ellipsis" className="text-[#CACFD8]">
            ...
          </p>,
        );
      }

      for (
        let i = Math.max(2, currentPage - 1);
        i <= Math.min(totalPages - 1, currentPage + 1);
        i++
      ) {
        pages.push(
          <p
            key={i}
            onClick={() => onPageChange(i)}
            className={`cursor-pointer ${
              currentPage === i
                ? "text-white"
                : "text-[#CACFD8] hover:text-white"
            }`}
          >
            {i}
          </p>,
        );
      }

      if (currentPage < totalPages - 2) {
        pages.push(
          <p key="end-ellipsis" className="text-[#CACFD8]">
            ...
          </p>,
        );
      }

      pages.push(
        <p
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
          className={`cursor-pointer ${
            currentPage === totalPages
              ? "text-white"
              : "text-[#CACFD8] hover:text-white"
          }`}
        >
          {totalPages}
        </p>,
      );
    }

    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="mx-auto mt-[64px] flex h-[70px] max-w-[499px] flex-row items-center gap-6 rounded-[12px] bg-[#011D1C] px-6">
      <p
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        className={`cursor-pointer pl-[44px] font-normal leading-[100%] tracking-[0%] ${
          currentPage > 1
            ? "text-[#CACFD8] hover:text-white"
            : "cursor-not-allowed text-gray-500"
        }`}
      >
        Previous
      </p>
      {renderPaginationNumbers()}
      <div
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
        className={`flex cursor-pointer items-center gap-2 ${
          currentPage < totalPages
            ? "text-[#4FBA6D] hover:text-[#3da959]"
            : "cursor-not-allowed text-gray-500"
        }`}
      >
        <span>Next</span>
        <img
          src="/assets/icons/Arrow-right-green.svg"
          alt="next"
          className="h-4 w-4"
        />
      </div>
    </div>
  );
};
